import type { IdentityInterface, ModelInterface } from '@nts/std/interfaces';
import { DomainModelCollection } from './domain-model-collection';


export class SearchResultlCollection<TItem extends ModelInterface<TIdentity>, TIdentity extends IdentityInterface>
    extends DomainModelCollection<TItem, TIdentity> {

}
